const scrollEventStickyNav = {
	el: {
		header: document.querySelector('.header'),
		mainWrapper: document.querySelector('.wrapper'),
		stickyElement: document.querySelector('.js-sticky-nav')
	},

	fxHandleStickyElementOnScroll() {
		// I know about sticky property in css, but I had to do in javascript because header has logo with box shadow and position out of header, that´s why I did everything with javascript

		// check if page has sticky element
		if (!this.el.stickyElement) return

		// save current padding top value as a string
		let mainWrapperPaddingTopValue = window.getComputedStyle(this.el.mainWrapper).getPropertyValue('padding-top')

		// convert string padding top to a number
		let mainWrapperPaddingTopNumber = parseInt(mainWrapperPaddingTopValue, 10)

		// get height of sticky element
		const stickyNavHeight = this.el.stickyElement.offsetHeight

		// final position is equal sticky element initial position minus height of header
		let stickyFinalPosition = this.el.stickyElement.offsetTop - this.el.header.offsetHeight - stickyNavHeight

		// add listener scroll
		window.addEventListener('scroll', () => {
			// check if scroll has reached sticky element
			if (stickyFinalPosition > window.scrollY) {
				// if not - remove classes on elements and add padding top initial value on main
				this.el.stickyElement.classList.remove('pinned')
				this.el.header.classList.remove('sticky-nav-pinned')
				this.el.mainWrapper.style.paddingTop = `${mainWrapperPaddingTopNumber}px`
			} else {
				// if yes - add classes and new padding top value on main
				this.el.stickyElement.classList.add('pinned')
				this.el.header.classList.add('sticky-nav-pinned')
				this.el.mainWrapper.style.paddingTop = `${mainWrapperPaddingTopNumber + stickyNavHeight}px`
			}
		})
	},

	init() {
		window.addEventListener('load', () => this.fxHandleStickyElementOnScroll())
	}
}

scrollEventStickyNav.init()